import * as React from "react";
import PropTypes from "prop-types";
import { nanoid } from "nanoid";
const StravaIframe = ({ url }) => {
  return (
    <div className="strava">
      <iframe
        title={nanoid()}
        loading="lazy"
        src={url}
        width="100%"
        height="420"
      />
    </div>
  );
};

StravaIframe.propTypes = {
  url: PropTypes.string,
};

export default StravaIframe;
